import {useUserStore} from "@/stores/UserStore";

export function ctrlPermissions(permission) {
  let permissions = useUserStore().permissions;
  // console.log("permissions on permissions.js",permissions);
  // console.log("permission",permission);

  if (
    Object.keys(permissions).length > 0 &&
    permission &&
    permission.length > 0
  ) {
    let youCan = false;
    permission.forEach((section) => {
      let found = permissions.find((element) => element == section);
      if (found) {
        youCan = true;
      }
    });
    return youCan;
  }

  return false;
}

export async function ctrlPermissionsRoot(requiredPermissions) {
  const userStore = useUserStore();

  if (!requiredPermissions || requiredPermissions.length === 0) return true; // no permissions needed explicitly

  // Permissions explicitly from the user store (flat array)
  const availablePermissions = userStore.permissions;

  // Explicit and correct permission check
  const hasPermission = requiredPermissions.some(perm => availablePermissions.includes(perm));

  return hasPermission;
}

